export default {
    // Left nav menu
    general: "General",
    dashboard: "Dashboard",
    customers: "Customers",
    customer: "Customer",
    user_tokens: "User Tokens",
    people: "People",
    devices: "Devices",
    subscriptions: "Subscriptions",
    support: "Support",
    service_tickets: "Service Tickets",
    rma: "RMA",
    work_orders: "Work Orders",
    notifications: "Notifications",
    configuration: "Configuration",
    settings: "Settings",
    mysql: "MySQL",

    fe_menu_quote_requests: "Requests",
    fe_menu_rfq_requests: "Requests for Quote",
    fe_menu_rfq: "Requests for Quote",
    fe_menu_quotes: "Estimates",
    fe_menu_po: "Purchase Orders",
    fe_menu_orders: "Orders",
    fe_menu_invoices: "Invoices",
    fe_menu_parts: "Parts",
    fe_menu_bills: "Bills",
    fe_menu_bill_payments: "Payments Made",
    fe_menu_invoice_payments: "Payments Received",
    fe_menu_inventory_receipts: "Purchase Receives",

    additional_details: "Additional Details",

    email_add_front: "Once valid, press",
    enter_key: "Enter",
    email_add_end: "to add new email.",
    no_results_matching: "No results matching",
    select_mod_lang: "Select a module to view and the language to translate",
    select_email: "To",
    email_cc: "CC",
    email_bcc: "BCC",
    select_caps: "SELECT",
    has_user_account: "Login Enabled",
    no_users_available: "No Users Available",
    no_devices_available: "No Devices Available",
    add_permission: "Add permission",
    edit_language: "Select a language to edit",
    language_properties: "Select a language to view it's properties",
    userProfile: "My Profile",
    userAddresses: "My Addresses",
    userPhones: "My Phone Numbers",
    userEmails: "My Emails",
    userOrganizations: "My Organizations",
    notificationSettings: "Notification Settings",
    commissions: "Commissions",
    sensors: "Sensors",
    temperature: "Temperature",
    overview: "Overview",
    dashboardOverview: "Dashboard Overview",
    help: "Knowledge Center",
    user: "User",
    save: "Save",
    submit: "Submit",
    submit_information: "Submit Information",
    clear: "Clear",
    continue: "Continue",
    cancel: "Cancel",
    collapse: "Collapse",
    reload: "Reload",
    close: "Close",
    add: "Add",
    logOut: "Log Out",
    search: "Search",
    default: "Default",
    loginNow: "Sign In",
    createAccount: "Sign up now",
    getStarted: "Get Started",
    dontHaveAn: "Don't have an",
    accountYet: "account yet?",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    bySigningUpYouAgreeTo: "By signing up, you are indicating that you have read and agree to the",
    and: "and",
    helpsEngineersContractors: "helps engineers, contractors, precasters and testing labs simplify their concrete monitoring process.",
    loginToAdmin: "Login",
    enterUsernameAndPasswordToAccessControlPanelOf: "Enter username and password to access control panel of",
    havingAnAccount: "Already have an account?",
    quickLinks: "Quick Links",
    toggle: "Toggle",
    yes: "Yes",
    no: "No",
    ok: "Ok",
    users_profile: "User Profile",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    my_addresses: "My Addresses",
    my_phones: "My Phones",
    my_emails: "My Emails",
    my_notifications: "My Notifications",
    activeUsers: "Active Users",
    active: "Active",
    inactive: "Inactive",
    add_new: "Add New",
    addNew: "Add New",
    refresh: "Refresh",
    readMore: "Read More",
    assignNow: "Assign Now",
    new: "New",
    pending: "Pending",
    update: "Update",
    back: "Back",
    name: "Name",
    email: "Email",
    editMember: "Edit Member",
    title: "Title",
    fullScreen: "Full Screen",
    apply: "Apply",
    noItemsFound: "No Items Found",
    devicesShare: "Devices Share",
    device_profile: "Device Profile",
    customerOverview: "Customer Overview",
    editUser: "Edit User",
    addNewUser: "Add New User",
    recentUsers: "Recent Users",
    recentComments: "Recent Comments",
    recentNotifications: "Recent Notifications",
    messages: "Messages",
    english: "English",
    edit: "Edit",
    activity: "Activity",
    message: "Message",
    itsFree: "It’s free!",
    signUp: "Create Account",
    login: "Login",
    signInNow: "Sign in now.",
    forgotPassword: "Forgot password",
    resetPassword: "Reset password",
    backToSignIn: "Back to sign in",
    forgotyourPassword: "Forgot your password?",
    enterYourCellToSendYouAResetLink: "No problem, we'll help you reset it. Simply enter your mobile telephone number to receive a reset link",
    pleaseEnterYourPasswordToReset: "Please enter a new password. Your new password must contain at least 8 characters, 1 uppercase, 1 number and 1 symbol.",
    deviceLog: "Device Log",

    confirm_unschedule_header: "Are you sure you want to unschedule?",
    confirm_delete_header: "Are you sure you want to delete?",
    confirm_delete_message: "Are you sure you want to delete?",
    confirmDelete: "This action is not reversible!",
    delete_address: "This will delete this address permanently!",
    delete_number: "This will delete this phone number permanently!",
    delete_email: "This will delete this email address permanently!",

    addPerson: "Add Person",
    addCustomer: "Add Customer",
    addDeviceBulk: "Add Bulk Devices",
    editDevice: "Edit Device",
    addModule: "Add Module",
    editModule: "Edit Module",
    addCompany: "Add Company",
    removeCompany: "Remove Company",
    addPermission: "Add Permission",
    editPermission: "Edit Permission",
    addPermissionTo: "Add Permission To ",

    customer_name: "Customer Name",
    customer: "Customer",

    addNumber: "Add Number",
    editNumber: "Edit Number",
    addEmail: "Add Email",
    editEmail: "Edit Email",
    addAddress: "Add Address",
    editAddress: "Edit Address",
    addPhone: "Add Phone",
    editPhone: "Edit Phone",

    // Fields from  database
    api_access_id: "Api Access",
    key: "Key",
    all_access: "All Access",
    controller: "Controller",
    deleted: "Deleted",
    delete: "Delete",
    created_by: "Created By",
    last_updated_by: "Last Updated By",
    last_modified_by: "Last Modified By",
    deleted_by: "Deleted By",
    date_created: "Date Created",
    date_modified: "Date Modified",
    date_deleted: "Date Deleted",
    token_id: "Token",
    access_token: "Access Token",
    account_id: "Account",
    ip_address: "IP Address",
    session_data: "Session Data",
    api_keys_id: "Api Keys",
    company_id: "Company",
    companies: "Companies",
    api_key: "Api Key",
    level: "Level",
    ignore_limits: "Ignore Limits",
    is_private_key: "Is Private Key",
    ip_addresses: "Ip Addresses",
    id: "ID",
    uri: "Uri",
    count: "Count",
    hour_started: "Hour Started",
    method: "Method",
    params: "Params",
    time: "Time",
    rtime: "Rtime",
    authorized: "Authorized",
    response_code: "Response Code",
    ckey: "Ckey",
    citem: "Citem",
    config_type: "Config Type",
    language_id: "Language",
    language: "Language",
    languages: "Languages",
    status: "Status",
    status_id: "Status",
    line_id: "Line",
    key_id: "Key",
    lang_text: "Lang Text",
    module: "Module",
    lang_key: "Lang Key",
    login_type_id: "Login Type",
    login_type: "Login Type",
    control_panel_id: "Control Panel",
    primary_navigation: "Primary Navigation",
    timestamp: "Timestamp",
    data: "Data",
    company: "Company",
    company_short: "Company Short",
    website: "Website",
    correspondence_method: "Correspondence Method",
    correspondence_method_mail: "Correspondence Method: Mail",
    correspondence_method_electronic: "Correspondence Method: Electronic",
    electronic: "Electronic",
    mail: "Mail",
    tax_id_number: "Tax ID Number",
    credit_terms: "Credit Terms",
    currency_code: "Currency Code",
    credit_status: "Credit Status",
    credit_limit: "Credit Limit",
    notes: "Notes",
    logo: "Logo",
    parent_id: "Parent",
    account_number: "Account Number",
    nick_name: "Nickname",
    account_nickname: "Account Nickname",
    account_type_id: "Account Type",
    import_id: "Import",
    file_name: "File Name",
    entity_addresses_id: "Entity Addresses",
    object_ref: "Object Ref",
    object_id: "Object",
    address1: "Address 1",
    address2: "Address 2",
    city: "City",
    state: "State",
    zip_code: "Zip Code",
    zip_code_ext: "Zip Code Ext",
    country_id: "Country",
    address_type: "Address Type",
    prime: "Prime",
    primary_caps: "PRIMARY",
    primary: "Primary",
    entity_emails_id: "Entity Emails",
    email_type: "Email Type",
    email_address: "Email Address",
    primary_email_address: "Primary Email Address",
    entity_life_events_id: "Entity Life Events",
    event_type: "Event Type",
    select_a_language_to_edit: "Filter Lang",
    update_title: "Update title",
    update_article: "Update Article",
    save_articles: "Save new articles",
    confirm_remove_article: "Are you sure you'd like to remove this article?",
    removeArticle: "Remove Article",
    event_date: "Event Date",
    reminder: "Reminder",
    reminder_interval: "Reminder Interval",
    reminder_interval_type: "Reminder Interval Type",
    entity_phones_id: "Entity Phones",
    phone_type: "Phone Type",
    phone_code_id: "Phone Code",
    phone_number: "Phone Number",
    phone_extension: "Phone Extension",
    device_id: "Device",
    version: "Firmware Version",
    change_log: "Change Log",
    battery_full: "Battery Full",
    battery_empty: "Battery Empty",
    device_log_id: "Device Log",
    battery: "Battery",
    signal_quality: "Signal Quality",
    signal: "Signal",
    queued_records: "Queued Records",
    queued: "Queued",
    low: "Low",
    high: "High",
    avg: "Avg",
    elapsed_time: "Elapsed Time",
    power_mode: "Power Mode",
    device_start: "Device Start",
    device_end: "Device End",
    sim: "Sim",
    imei: "IMEI/MEID",
    sensor_data: "Sensor Data",
    device_ports_id: "Device Ports",
    port_number: "Port Number",
    sensor_type_id: "Sensor Type",
    last_measurement: "Last Measurement",
    public_id: "Public ID",
    app_organisation_id: "App Organisation",
    mobile_provider_id: "Mobile Provider",
    device_type: "Device Type",
    purchase_date: "Purchase Date",
    warranty_period: "Warranty Period",
    record_interval: "Record Interval",
    upload_interval: "Upload Interval",
    interval: "Interval",
    last_read: "Last Read",
    last_record_date: "Last Record Date",
    command: "Command",
    project_id: "Project",
    structure: "Structure",
    client_name: "Client Name",
    project_name: "Project Name",
    job_number: "Job Number",
    sensor_type: "Sensor Type",
    sensor_description: "Sensor Description",
    measurement_symbol: "Measurement Symbol",
    imperial_symbol: "Imperial Symbol",
    metric_symbol: "Metric Symbol",
    round_precision: "Round Precision",
    subscription_id: "Subscription ID",
    transaction_id: "Transaction ID",
    transaction_amount: "Transaction Amount",
    device_seats: "Device Seats",
    expire_date: "Expire Date",
    region_id: "Region",
    country_name: "Country Name",
    country_iso_2: "Country Iso 2",
    country_iso_3: "Country Iso 3",
    num_code: "Num Code",
    phone_code: "Phone Code",
    iso: "Iso",
    nicename: "Nicename",
    iso3: "Iso3",
    numcode: "Numcode",
    phonecode: "Phonecode",
    postal_code_id: "Postal Code",
    postal_code: "Postal Code",
    gps_lat: "Gps Lat",
    gps_lng: "Gps Lng",
    state_id: "State",
    county: "County",
    postal_class: "Postal Class",
    region_name: "Region Name",
    region_iso_2: "Region Iso 2",
    region_iso_3: "Region Iso 3",
    state_name: "State Name",
    state_abbrv: "State Abbrv",
    login: "Login",
    reason: "Reason",
    average: "Average",
    mobile_provider: "Mobile Provider",
    notification_object_id: "Notification Object",
    notification_name: "Notification Name",
    event: "Event",
    module_name: "Module Name",
    function_name: "Function Name",
    field_updated: "Field Updated",
    custom_where: "Custom Where",
    timing: "Timing",
    icon: "Icon",
    max_attempts: "Max Attempts",
    email_msg: "Email Msg",
    text_msg: "Text Msg",
    feed_msg: "Feed Msg",
    notification_queue_id: "Notification Queue",
    subject: "Subject",
    accepted: "Accepted",
    icon_class: "Icon Class",
    sent: "Sent",
    hidden: "Hidden",
    sms_log_id: "Sms Log",
    message_id: "Message",
    api_message_id: "Api Message",
    error_code: "Error Code",
    error: "Error",
    error_description: "Error Description",
    phone_numbers: "Phone Numbers",
    notification_to_people_id: "Notification To People",
    people_id: "People",
    notification_type_id: "Notification Type",
    notification_type: "Notification Type",
    notifications_id: "Notifications",
    object_link: "Object Link",
    read_flag: "Read Flag",
    sent_flag: "Sent Flag",
    alert_method: "Alert Method",
    smtp_log: "Smtp Log",
    option_id: "Option",
    category_id: "Category",
    option: "Option",
    value: "Value",
    category: "Category",
    prefix: "Prefix",
    first_name: "First Name",
    middle_name: "Middle Name",
    last_name: "Last Name",
    suffix: "Suffix",
    combined_name: "Combined Name",
    nick_name: "Nick Name",
    job_title: "Job Title",
    gender: "Gender",
    photo: "Photo",
    user_time_zone: "Time Zone",
    unit_of_measure: "Unit Of Measure",
    theme: "Theme",
    notification_method: "Notification Method",
    link_id: "Link",
    permission_role_id: "Permission Role",
    people_to_contact_categories_id: "People To Contact Categories",
    contact_category_id: "Contact Category",
    object: "Object",
    account_type: "Account Type",
    field_id: "Field",
    fieldname: "Field Name",
    tablename: "Table Name",
    function_id: "Function",
    permission: "Permission",
    permission_token: "Permission Token",
    module_id: "Module",
    exempt: "Exempt",
    functions_to_privileges_id: "Functions To Privileges",
    privilege_id: "Privilege",
    display_name: "Display Name",
    privilege: "Privilege",
    privileges_to_roles: "Privileges To Roles",
    role_id: "Role",
    role: "Role",
    table_id: "Table",
    position: "Position",
    alias: "Alias",
    placeholder: "Placeholder",
    placeholder_word_phrase: "Type search word or phrase...",
    rules: "Rules",
    fillable: "Fill",
    protected: "Protect",
    is_hidden: "Hidden",
    is_searchable: "Search",
    type: "Type",
    input_type: "Input Type",
    length: "Length",
    default_value: "Default Value",
    attributes: "Attributes",
    index_type: "Index Type",
    aggregate: "Aggregate",
    comments: "Comments",
    date_sync: "Date Sync",
    relation_id: "Relation",
    relation_type: "Relation Type",
    reference_column_id: "Reference Column",
    foreign_object_name: "Object Name",
    foreign_model_name: "Foreign Model Name",
    is_user_def: "Is User Def",
    edit_sql_relationship: "Edit Relationship",
    add_sql_relationship: "Add Relationship",
    delete_sql_relationship: "Delete Relationship",
    table_name: "Table Name",
    user_field_id: "User Field",
    access_control: "Access Control",
    user_function_id: "User Function",
    deny: "Deny",
    user_privilege_id: "User Privilege",
    GRANTEE: "GRANTEE",
    TABLE_CATALOG: "TABLE CATALOG",
    PRIVILEGE_TYPE: "PRIVILEGE TYPE",
    IS_GRANTABLE: "IS GRANTABLE",
    user_role_id: "User Role",
    token_object_id: "Token Object",
    object_name: "Object Name",
    granted_by_user_id: "Granted By User",
    user_tracking_id: "User Tracking ID",
    session_id: "Session ID",
    request_method: "Request Method",
    function: "Function",
    post_data: "Post Data",
    url: "Url",
    client_ip: "Client Ip",
    user_agent: "User Agent",
    activate: "Activate",
    deactivate: "Deactivate",
    referer_page: "Referer Page",
    time_stamp: "Time Stamp",
    username: "Username",
    password: "Password",
    default_account_id: "Default Account",
    last_account_id: "Last Account",
    default_calendar_id: "Default Calendar",
    activation_code: "Activation Code",
    forgotten_password_code: "Forgotten Password Code",
    forgotten_password_time: "Forgotten Password Time",
    remember_code: "Remember Code",
    last_login: "Last Login",
    users_to_accounts_id: "Users To Accounts",
    request_date: "Request Date",
    node_id: "Node ID",
    addWO: "Add Work Order",
    wo_number: "Work Order Number",
    wo_history: "Work Order History",
    return_address: "Return Address",
    warranty_repair: "Warranty Repair",
    inbound_tracking_number: "Inbound Shipments",
    reason_for_return: "Reason For Return",
    contact_name: "Contact Name",
    contact_phone: "Contact Phone",
    contact_email: "Contact Email",
    node_received: "Node Received",
    received: "Received",
    quoted: "Quoted",
    approved: "Approved",
    confirm: "Confirm",
    work_performed: "Work Performed",
    date_performed: "Date Performed",
    performed_by: "Performed By",
    outbound_tracking_number: "Outbound Shipments",
    track: "Track",
    printDialog: "Preview",
    print: "Print",
    save_and_print: "Save + Print",
    printClose: "Close",
    emailDialog: "Email",
    is_owner: "Is this user an owner of this company?",
    is_owner_yes: "Is Owner: Yes",
    is_owner_no: "Is Owner: No",
    confirm_remove_beginning: "Are you sure you'd like to remove ",
    confirm_remove_end: " from this user?",
    save_changes: "Save changes",
    undo_changes: "Undo",
    select_company: "Select a company to view their permissions",
    select_a_company: "Select a company",
    send: "Send",
    stripe_id: "Stripe ID",
    requote: "Requote Estimate",
    clearNotifDialog: "Clear Notifications",
    confirmClearNotif: "Are you sure you want to mark all notifications as read?",
    notifWarning: "WARNING: This cannot be undone!",
    readAll: "Mark All As Read",
    permissions: "Permissions",
    help_articles: "Help Articles",
    create_article: "Create Article",
    translate_articles: "Translate Articles",
    create_notification: "Create Notification",
    object_link: "Object Link",
    login_popup: "Login Popup",
    notification_to: "To",
    person: "Person",
    firmware: "Firmware",
    firmware_filter_operator: "Firmware Filter",
    modifyCompany: "Modify Company",
    uploadImage: "Upload Image",
    uploaded_by: "Uploaded By",
    active_languages: "Active Languages",
    create_articles: "Create Articles",
    all: "All",
    no_devices: "No devices associated to this account.",
    active_only: "Active Only",
    no_permissions: "This module has no permissions",
    select_module: "Select a module to view permissions",
    permission_help: "Help",
    notice: "NOTICE",
    employee: "Employee",
    distributor: "Distributor",
    home: "Home",
    mobile: "Mobile",
    work: "Work",
    billing: "Billing",
    shipping: "Shipping",
    other: "Other",
    f: "Fahrenheit",
    c: "Celsius",
    remove_company_from_user: "Remove company from user",
    modify_person: "Modify Person",
    required: "Required",
    required_zip_code: "Item must be at least 5 numbers",
    required_email: "Email must be valid",
    required_url: "URL must be valid",
    create_article: "Create Article",
    select_module: "Select a module to view it's articles",
    no_articles_found: "No articles found for ",
    select_a_module: "Select a module",
    select_a_language: "Select a language",
    article_title: "Article Title",
    write_article: "Write a new article...",
    filter_modules: "Filter modules",
    loading: "Loading...",
    create_new_user: "Create New User",
    create_new_person: "Create New Person",
    manual: "Manual",
    new_user_form: "New User Form",
    do_not_show: "Do not show again",
    view_all_notifications: "View All Notifications",
    show_differentials: "Show Differentials",
    hide_differentials: "Hide Differentials",
    new_person_form: "New Person Form",
    invite: "Invite",
    create_user_account_yes: "Create User Account: Yes",
    create_user_account_no: "Create User Account: No",
    invite_person: "Invite Person",
    invite_user: "Invite User",
    userInvite: "User Invite",
    logarithmic: "Logarithmic",
    exponential: "Exponential",
    hyperbolic: "Hyperbolic",
    suspended: "Suspended",
    retired: "Retired",
    demo: "Demo",
    normal: "Normal",
    year: "Year",
    one_year: "1 Year",
    interval_450: "1 Min (Test Purposes Only)",
    interval_600: "10 Min",
    interval_4500: "10 Min",
    interval_6750: "15 Min",
    interval_9000: "20 Min",
    interval_13500: "30 Min",
    interval_27000: "60 Min",
    initializing: "Initializing...",
    unassigned: "Unassigned",
    pause_caps: "PAUSE",
    live_caps: "LIVE",
    input_too_long: "Input is too long",
    breaks: "Breaks",
    required_ttf: "Must select TTF Model",
    can_not_be_zero: "Item cannot be 0",
    can_not_be_negative: "Item cannot be negative",
    value_too_high: "Value is too high",
    none: "None",
    date_cast_caps: "DATE CAST",
    activate_user_account: "Activate User Account",
    add_new_article: "Add new article",
    modify_person: "Modify Person",
    mobile_phone: "Mobile Phone",
    requested: "Requested",
    working: "Working",
    closed: "Closed",
    wo_info: "Work Order Info",
    date_requested: "Date Requested",
    inbound_tracking: "Inbound Tracking",
    outbound_tracking: "Outbound Tracking",
    track_inbound: "Track Inbound",
    track_outbound: "Track Outbound",
    history: "History",
    select_new_quote: "Must select new quote",
    select_different_quote: "Must select a different quote",
    tracking: "Tracking",
    weight: "Weight",
    part_weight: "Part Weight",
    packaging_weight: "Packaging Weight",
    activity_date: "Activity Date",
    modules: "Modules",
    get: "Get",
    put: "Put",
    patch: "Patch",
    post: "Post",
    filter: "Filter",
    group: "Group",
    marketing: "Marketing",
    tokens: "Tokens",
    equal_to: "Equal To",
    less_than: "Less Than",
    greater_than: "Greater Than",
    less_than_or_equal_to: "Less Than or Equal To",
    greater_than_or_equal_to: "Greater Than or Equal To",
    configuration: "Configuration",
    must_select_option: "Must select option",
    must_select_at_least_one: "Must select at least one option",
    number_email_required: "Mobile number is required",
    number_email: "Mobile number",
    request_reset: "Request reset",
    check_for_instructions: "Please check your email or mobile phone for instructions.",
    password_required: "Password is required",
    remember_me: "Remember me",
    valid_username: "Username must be valid",
    open: "Open",
    Delivered: "Delivered",
    number: "Number",
    must_match: "Must match",
    passwords_must_match: "Passwords must match",
    require_one_caps: "Must be at least one capital letter",
    require_one_lowercase: "Must be at least one lowercase letter",
    require_one_number: "Must be at least one number",
    require_one_special: "Must be at least one special character: !@#$%^&*",
    require_min_8: "Must be 8 or more characters",
    require_max_16: "Must be 16 or less characters",
    require_max_100: "Must be 100 or less characters",
    require_one_period: "Can only be one period",
    require_one_at: "Can only be one @ symbol",
    min_is: "Min is",
    min_length_is: "Min length is",
    max_is: "Max is",
    max_length_is: "Max length is",
    length_must_be: "Length must be",
    invalid_characters: "Invalid characters",
    invalid_email_format: "Invalid email format",
    add_new_seat: "Purchase New Seat",
    checkout: "Checkout",
    require_letter_start: "Must start with a letter",
    account_creation_opening_info: "Please complete the information below, as soon as possible. You will only have 24 hours before the invitaion expires.",
    subscribe: "Subscribe",
    valid_username_required: "A valid username is required",
    add_payment_method: "Add Payment Method",
    select_payment_method: "Select a payment method",
    select_payment_period: "Select payment period",
    auto_renew: "Auto Renew",
    primary_billing_email: "Primary Billing Email",
    no_change_primary_billing_email: "Please note, primary billing email address cannot be changed.",
    edit_subscription: "Edit Subscription",
    cancel_subscription: "Cancel Subscription",
    issued: "Issued",
    revoked: "Revoked",
    revoke: "Revoke",
    owner: "Owner",
    create: "Create",
    leave: "Leave",
    create_token: "Create Token",
    confirm_leave_company: "Are you sure you want to leave this company?",
    access_tokens: "Access Tokens",
    battery_profile: "Battery Profile",
    no_subscriptions_past_due: "No Subscriptions Past Due",
    remove_card: "Remove Card",
    update_default_card: "Update Default Card",
    good: "Good",
    medium: "Medium",
    poor: "Poor",
    imperial: "Imperial",
    metric: "Metric",
    active_sessions: "Active Sessions",
    subscription: "Subscription",
    user_id: "User ID",
    select_a_session: "Select Session",
    active_session_delete_confirm: "Are you sure you want to terminate the selected session?",
    active_sessions_delete_confirm: "Are you sure you want to terminate all sessions?",
    delete_active_session: "Delete Active Session",
    delete_active_sessions: "Delete Active Sessions",
    delete_all: "Delete All",
    user_session: "'s session",
    no_cards: "No cards on file",
    expires: "Expires",
    set_default: "Set as default",
    active_subscriptions: "Active Subscriptions",
    buy_seats: "Buy seats",
    no_data: "No data to show",
    total: "Total",
    per_month: "per month",
    per_year: "per year",
    name_on_card: "Name on card",
    cardholder_email: "Cardholder email",
    confirm_cancel_subscription:
        "Are you sure you'd like to cancel this subscription? This subscription will stay active until the next expire date. Money will not be refunded.",
    subscription_plan: "Subscription plan:",
    amount_of_seats: "Amount of seats:",
    price: "Price ($)",
    start_date: "Start Date",
    start_time: "Start Time",
    end_date: "End date:",
    invoice_id: "Invoice ID",
    confirm_remove_card: "Are you sure you'd like to remove this card?",
    make_default: "Make this your default payment method?",
    add_article: "Add article",
    edit_articles: "Edit articles",
    search_dots: "Search...",
    knowledge_center: "Knowledge Center",
    no_data_available: "No data available",
    card_ending_in: "Card ending in",
    greater_than_or_equal_to_one: "Item must be greater than or equal to 1",
    fill_all_card_info: "Fill in all card info!",
    monthly: "Monthly",
    yearly: "Yearly",
    fields: "Fields",
    relationships: "Relationships",
    no_subscriptions: "There are no current subscriptions on file",
    sensor_types: "Sensor Types",
    add_sensor: "Add Sensor",
    edit_sensor: "Edit Sensor",
    delete_sensor: "This will delete this sensor type permanetly!",
    sync: "Sync",
    add_firmware_version: "Add Firmware Version",
    edit_firmware_version: "Edit Firmware Version",
    delete_firmware_version: "Delete Firmware Version",
    battery_alerts_switch: "Battery Alerts: Off/On",
    login_attempts: "Login Attempts",
    login_attempt: "Login Attempt",
    edit_permissions: "Edit Permissions",
    save_article: "Save this article",
    delete_login_attempt: "This will delete this login attempt permanetly!",
    battery_data: "No battery data available",
    signal_data: "No signal data available",
    device_code: "Device QR Code",
    get_code: "Generate QR Code",
    scan_code: "Scan QR Code",
    choose_image: "Choose an image.",
    replace: "Replace",
    mobile_phone_notification: "Mobile Number For Notifications",
    email_address_notification: "Email Address For Notifications",
    no_notifications: "No notifications for this user",
    change_view: "Change View",
    no_companies: "No companies found",
    no_permission: "Permission Denied",
    no_permission_text: "You do not have permission to perform this action.",
    relationship: "Relationship",
    countrySelectorLabel: "Country code",
    countrySelectorError: "Choose country",
    phoneNumberLabel: "Phone number",
    example: "e.g.",
    notify_oops: "Oops something went wrong.",
    project_details: "Project Details",
    user_account: "Has User Account",
    cancelled: "Cancelled",
    work_completed: "Work Completed",
    session_timed_out: "Session timed out",
    incorrect_value: "Incorrect value",
    permission_templates: "Permission Templates",
    no_work_orders: "No Work Orders",
    select_login_type_base: "Select a login type",
    select_login_type: "Select a login type to view permission templates",
    save_template: "Save Template",
    apply_template: "Apply Template",
    menu: "Menu",
    addToken: "Add Token",
    user_to_give_token: "User to give token",
    go_back: "Go Back",
    stripe_subscription_id: "Stripe Subscription ID",
    amount: "Amount",
    period_start: "Period Start",
    period_end: "Period End",
    no_articles_available: "No articles available in this module",
    return: "Return",
    click_to_activate: "Click to activate",
    click_to_deactivate: "Click to deactivate",
    complete: "Complete",
    complete_procedure: "Complete Procedure",
    complete_station: "Complete Station",
    receive_device: "Mark device as received",
    date_last_updated: "Last updated: ",
    void: "Void",
    current_wo_delete_confirm: "Are you sure you want to void the current Work Order? Be aware, there is no way to reverse this!",
    delete_wo: "Void Work Order",
    helpful: "Helpful",
    yes_helpful: "This was helpful",
    no_helpful: "This was not helpful",
    new_request: "New Request",
    in_progress: "In Progress",
    open_extended: "Open Extended",
    parts_on_order: "Parts On Order",
    on_hold: "On Hold",
    awaiting_info: "Awaiting Info",
    awaiting_funding: "Awaiting Funding",
    deferred: "Deferred",
    call: "Call",
    display_shipping_info: "Shipping Info",
    recent_readings: "Recent Device Readings",
    remove_company: "Remove Company",
    send_email: "Send Email",
    directions: "Directions",
    show_map: "Show Map",
    username_not_avail: "Username Not Available",
    username_avail: "Username Available",
    form_builder: "Frontend Builder",
    add_form_builder: "Add Form",
    form: "Form",
    forms: "Forms",
    sub_forms: "Sub Forms",
    select_form: "Select Form",
    min_length: "Min Length",
    max_length: "Max Length",
    delete_form_message: "Are you sure you want to delete this form?",
    delete_form_heading: "Delete Form",
    delete_form_field_message: "Are you sure you want to delete this form field?",
    delete_form_field_heading: "Delete Form Field",
    delete_phone_for_notifications: "This action will stop notifications coming to this phone.",
    delete_email_for_notifications: "This action will stop notifications coming to this email.",
    integer_required: "Integer Required",
    decimal_required: "Decimal Required",
    not_unique: "Not Unique",
    delete_entity_address: "Delete Address",
    delete_entity_phone: "Delete Phone",
    delete_entity_email: "Delete Email",
    new_primary_address: "New Primary Address",
    new_primary_phone: "New Primary Phone",
    new_primary_email: "New Primary Email",
    text_copied: "Text Copied",
    tank_products: "Tank Products",
    delete_tank_product: "Delete Tank Product",
    add_tank_product: "Add Tank Product",
    edit_tank_product: "Edit Tank Product",
    product_name: "Product Name",
    specific_gravity: "Specific Gravity",
    total_active_sensors: "Total Active Sensors",
    entity_phone_details: "Phone Details",
    entity_address_details: "Address Details",
    entity_email_details: "Email Details",
    tank_types: "Tank Types",
    delete_tank_type: "Delete Tank Type",
    add_tank_type: "Add Tank Type",
    edit_tank_type: "Edit Tank Type",
    image_url: "Image Url",
    tank_type: "Tank Type",
    slug: "Slug",
    formula: "Formula",
    comments: "Comments",
    width: "Width",
    height: "Height",
    diameter: "Diameter",
    after_save_profile: "After Save: Go to profile",
    after_save_stay: "After Save: Stay here",
    close_onsave: "After Save: Close Dialog",
    mobile_network: "Mobile Network",
    move_products: "Move Products",
    reprovision: "Reprovision",
    delete_device: "Delete Device",
    monitor_device: "Monitor Device",
    reprovision_device: "Are you sure you want to reprovision this device? Reprovisioning will permanently delete all data, including device history.",
    device_identifier: "Device Identifier",
    sim_provider: "SIM Provider",
    term: "Term",
    renewal_date: "Renewal Date",
    sim_paused: "Sim Paused",
    sim_activated: "Sim Activated",
    scan_again: "Scan Again",
    surge_protection: "Surge Protection",
    parts: "Parts",
    part_spec: "Spec",
    delete_part: "Delete Part",
    add_part: "Add Part",
    edit_part: "Edit Part",
    dta_part_code: "DTA Part Code",
    part_number: "Part Number",
    part_number_short: "Part #",
    part_name: "Part Name",
    material: "Material",
    od_dimension: "OD Dimension",
    od_unit_id: "OD Unit",
    height_dimension: "Height Dimension",
    height_unit_id: "Height Unit",
    id_dimension: "ID Dimension",
    id_unit_id: "ID Unit",
    batch_size: "Batch Size",
    batch_size_pcs: "Batch Size (PCS)",
    authorized_by_id: "Authorized By",
    authorized_date: "Authorized Date",
    authorization_rev: "Authorized Revision",
    sales_price: "Sales Price",
    salesman: "Salesman",
    jig_assembly_id: "Jig Assembly ID",
    part_details: "Part Details",
    part_profile: "Part Profile",
    parts_spec: "Parts Spec",
    delete_part_spec: "Delete Part Spec",
    add_part_spec: "Add Part Spec",
    edit_part_spec: "Edit Part Spec",
    item: "Item",
    lower_limit: "Lower Limit",
    upper_limit: "Upper Limit",
    unit: "Unit",
    production_stations: "Production Stations",
    delete_production_station: "Delete Production Station",
    add_production_station: "Add Production Station",
    edit_production_station: "Edit Production Station",
    short_code: "Short Code",
    station: "Station",
    production_lines: "Production Lines",
    delete_production_line: "Delete Production Line",
    add_production_line: "Add Production Line",
    edit_production_line: "Edit Production Line",
    production_line: "Production Line",
    production_procedures: "Production Procedures",
    production_procedure: "Production Procedure",
    machines: "Machines",
    delete_machines: "Delete Machine",
    add_machines: "Add Machine",
    edit_machines: "Edit Machine",
    page_refreshed: "Page Refreshed",
    delete_qr_code: "Delete QR Code",
    no_cameras: "No cameras detected",
    configure_environment: "Configure Environment",
    pref_cleared: "Preferences Cleared",
    credentials: "Credentials",
    no_rear_camera: "No rear camera detected",
    no_front_camera: "No front camera detected",
    switch_camera: "Switch Camera",
    delete_rfid: "Delete RFID",
    has_front_camera: "Has Front Camera",
    has_rear_camera: "Has Rear Camera",
    default_camera: "Default Camera",
    primary_login: "Primary Login",
    front_camera_access: "Front camera access",
    rear_camera_access: "Rear camera access",
    not_checked_for_camera: "Not checked for camera",
    clear_preferences: "CLEAR PREFERENCES",
    remove_access: "REMOVE ACCESS",
    detect_enable: "DETECT/ENABLE",
    detect: "DETECT",
    unknown: "UNKNOWN",
    auto: "AUTO",
    front: "Front",
    rear: "Rear",
    receiving: "Receiving",
    scheduling: "Scheduling",
    qc_inspection: "QC Inspection",
    files: "Files",
    process: "Process",
    reorder: "Re-order",
    add_spec: "Add Spec",
    reorder_specs: "Re-order Specs",
    control_ll: "Control Lower Limit",
    control_ul: "Control Upper Limit",
    control_ll_short: "Control LL",
    control_ul_short: "Control UL",
    ll: "Lower Limit",
    ul: "Upper Limit",
    must_be_less_than: "Must be less than",
    must_be_greater_than: "Must be greater than",
    modify_part: "Modify Part",
    add_file: "Add File",
    edit_file: "Edit File",
    add_part_file: "Add Part File",
    delete_part_file: "Delete Part File",
    browse: "Browse",
    file_viewer: "File Viewer",
    delete_work_order: "Delete Work Order",
    add_work_order: "Add Work Order",
    edit_work_order: "Edit Work Order",
    part_id: "Part #",
    qty: "Qty",
    lot_number: "Lot Number",
    po_number: "PO Number",
    date_received: "Date Received",
    customer_po: "Customer PO",
    pattern: "Pattern",
    receive_parts: "Receive Parts",
    scan: "Scan",
    part_found: "Part Found",
    scan_barcode: "Scan Barcode",
    delete_production_procedure: "Delete Production Procedure",
    add_production_procedure: "Add Production Procedure",
    edit_production_procedure: "Edit Production Procedure",
    procedure_name: "Procedure Name",
    machine_id: "Machine",
    procedure_id: "Procedure",
    procedure: "Procedure",
    next_procedure: "Next Procedure",
    delete_machine: "Delete Machine",
    add_machine: "Add Machine",
    edit_machine: "Edit Machine",
    machine_name: "Machine Name",
    user_defined_fields: "User Defined Fields",
    delete_user_defined_field: "Delete User Defined Field",
    add_user_defined_field: "Add User Defined Field",
    edit_user_defined_field: "Edit User Defined Field",
    question: "Question",
    field_type: "Field Type",
    expand: "Expand",
    contract: "Contract",
    no_parts_available: "No Parts Available",
    edit_shipment: "Edit Shipment",
    all_companies: "All Companies",
    rescan: "Rescan",
    date: "Date",
    expiration_date: "Expiration Date",
    expiration_time: "Expiration Time",
    turn_around_days: "Turn Around Days",
    number_required: "Number Required",
    in_production: "In Production",
    prototype: "Prototype",
    quotation_number: "Quotation Number",
    quotation_date: "Quotation Date",
    quote_number: "Quote Number",
    quote_date: "Quote Date",
    customer_part_number: "Customer Part Number",
    sales_unit: "Sales Unit",
    part_cost: "Part Cost",
    remuneration_cost: "Remuneration Cost",
    location_label: "Location Label",
    add_another_address: "Add Another Address",
    remove: "Remove",
    decimals_allowed: "Decimals Allowed",
    in_warehouse: "In Warehouse",
    not_in_warehouse: "Not In Warehouse",
    setting: "Setting",
    batch_line: "Batch Line",
    continuous_line: "Continuous Line",
    add_station_procedure: "Add Station Procedure",
    delete_station_procedure: "Delete Station Procedure",
    set_prime: "Set Prime",
    part_stations: "Part Stations",
    delete_part_station: "Delete Part Station",
    add_part_station: "Add Part Station",
    edit_part_station: "Edit Part Station",
    station_id: "Station",
    pattern_number: "Pattern Number",
    minutes_to_complete: "Minutes To Complete",
    reorder_stations: "Re-order Stations",
    deleting: "Deleting",
    add_part_procedure: "Add Part Procedure",
    edit_part_procedure: "Edit Part Procedure",
    add_procedure_question: "Add Procedure Question",
    edit_procedure_question: "Edit Procedure Question",
    delete_procedure_question: "Delete Procedure Question",
    text: "Text",
    select: "Select",
    switch: "Switch",
    element_type: "Element Type",
    element_items: "Element Items",
    switch_items: "Switch Items",
    decimal: "Decimal",
    items_must_be_unique: "Items must be unique",
    required_piped_list: "Required piped list of length",
    no_pipe_at_ends: "Can not start or end with pipe",
    items_no_space_at_ends: "Items can not start or end with space",
    authorization_info: "Authorization Information",
    quote_info: "Quote Information",
    production: "Production",
    mass: "Mass",
    aged: "Aged",
    warehouse_qty: "Warehouse Qty",
    schedule: "Schedule",
    warehouse: "Warehouse",
    qc: "Quality Control",
    schedule_date: "Schedule Date",
    documents: "Documents",
    label: "Label",
    quality: "Quality",
    description: "Description",
    scenario: "Scenario",
    active_flag: "Active Flag",
    chip_color: "Chip Color",
    bg_color: "Bg Color",
    date_scheduled: "Date Scheduled",
    empty_box_location: "Empty Box Location",
    qc_check_interval: "QC Check Interval",
    view_shipment: "View Shipment",
    edit_delivery: "Edit Delivery",
    delete_delivery: "Delete Delivery",
    view_delivery: "View Delivery",
    quality_control: "Quality Control",
    quality_controls: "Quality Controls",
    delete_quality_control: "Delete Quality Control",
    add_quality_control: "Add Quality Control",
    edit_quality_control: "Edit Quality Control",
    view_quality_control: "View Quality Control",
    batch_id: "Batch ID",
    test_summary: "Test Summary",
    inspection_date: "Inspection Date",
    pass: "Pass",
    fail: "Fail",
    edit_batch: "Edit Batch",
    more: "More",
    username_not_set: "Username Not Set",
    not_available: "Not Available",
    result: "Result",
    dta_control: "DTA Control",
    batch_control_id: "Batch Control ID",
    payment_terms: "Payment Terms",
    delete_payment_term: "Delete Payment Term",
    add_payment_term: "Add Payment Term",
    edit_payment_term: "Edit Payment Term",
    term_days: "Term Days",
    default_ship_address_id: "Default Shipping Address",
    default_sold_address_id: "Default Billing Address",
    default_billing: "Default Billing",
    default_shipping: "Default Shipping",
    parts_spec_types: "Parts Spec Types",
    delete_parts_spec_type: "Delete Parts Spec Type",
    add_parts_spec_type: "Add Parts Spec Type",
    edit_parts_spec_type: "Edit Parts Spec Type",
    spec_type: "Spec Type",
    none_set_add_from_company: "None set, add from company profile",
    hold: "Hold",
    spec_type_id: "Spec Type",
    repack: "Repack",
    add_repack: "Add Repack",
    no_batches_for_part: "No batches for this part",
    create_package: "Create Package",
    processed_qty: "Processed Qty",
    repack_qty: "Repack Qty",
    shipping_unit: "Shipping Unit",
    shipments: "Shipments",
    delete_shipment: "Delete Shipment",
    add_shipment: "Add Shipment",
    edit_shipment: "Edit Shipment",
    sold_address_id: "Sold Address ID",
    ship_address_id: "Ship Address ID",
    date_shipped: "Date Shipped",
    carrier_id: "Carrier",
    shipment: "Shipment",
    back_to_list: "Back To List",
    total_removed: "Total Removed",
    total_processed: "Total Processed",
    hazardous_material: "Hazardous Material",
    invoices: "Invoices",
    delete_invoice: "Delete Invoice",
    add_invoice: "Add Invoice",
    edit_invoice: "Edit Invoice",
    sold_to_address_id: "Sold To Address",
    ship_to_address_id: "Ship To Address",
    salesman_id: "Salesman",
    bol_id: "BOL",
    shipping_method_id: "Shipping Method",
    date_due: "Date Due",
    invoice_sent: "Invoice Sent",
    create_invoice: "Create Invoice",
    invoice: "Invoice",
    invoice_and_packing: "Invoice and Packing List Number",
    invoice_date: "Invoice Date",
    approve: "Approve",
    approve_prototype: "Approve Prototype",
    packing_list: "Packing List",
    bill_of_lading: "Bill Of Lading",
    received_qty: "Received Qty",
    acceptance_test_qty: "Acceptance Test Qty",
    settings_menu: "Settings Menu",
    po: "PO",
    rec_qty: "Rec Qty",
    removed_qty: "Removed Qty",
    shipped_qty: "Shipped Qty",
    unit_cost: "Unit Cost",
    batch_cost: "Batch Cost",
    select_batch: "Select Batch",
    packages: "Packages",
    repack_by: "Repack By",
    part: "Part Details",
    select_part: "Select Part",
    available_qty: "Available Qty",
    view_package: "View Package",
    origin: "Origin",
    packing_lists: "Packing Lists",
    packing_list_create: "Create Packing List",
    delete_packing_list: "Delete Packing List",
    add_packing_list: "Add Packing List",
    edit_packing_list: "Edit Packing List",
    no_part_specs: "No Part Specs",
    batches: "Batches",
    create_packing_list: "Create Packing List",
    shipping_carrier: "Shipping Carrier",
    shipping_carriers: "Shipping Carriers",
    delete_shipping_carrier: "Delete Shipping Carrier",
    add_shipping_carrier: "Add Shipping Carrier",
    edit_shipping_carrier: "Edit Shipping Carrier",
    provider: "Provider",
    emergency_number: "Emergency Number",
    batch_number: "Batch Number",
    shipping_weight: "Shipping Weight",
    rate: "Rate",
    charges: "Charges",
    pack_view: "Pack View",
    batch_view: "Batch View",
    select_packs: "Select Packs",
    invoice_number_short: "Invoice #",
    disabled: "Disabled",
    create_batches: "Create Batches",
    continuous_schedule: "Continuous Schedule",
    work_orders_settings: "Work Orders Settings",
    delete_work_orders_setting: "Delete Work Orders Setting",
    add_work_orders_setting: "Add Work Orders Setting",
    edit_work_orders_setting: "Edit Work Orders Setting",
    date_begin: "Date Begin",
    date_complete: "Date Complete",
    performed_by_id: "Performed By",
    continuous_production: "Continuous Production",
    instructions: "Instructions",
    cycle_time: "Cycle Time",
    packing_list_number_short: "Packing List #",
    packing_list_search: "Type packing list or PO #...",
    shipped: "Shipped",
    delete_packing_list_confirm: "This will also delete all invoices and bill of ladings tied to this packing list.",
    print_invoice: "Print Invoice",
    print_all: "Print All",
    convert_to_purchase_order: "Convert to Purchase Order",
    reject_quote: "Reject Quote",
    mark_as_new: "Mark as New",
    mark_as_draft: "Mark as Draft",
    mark_as_approved: "Mark as Approved",
    mark_as_accepted: "Mark as Accepted",
    mark_as_sent: "Mark as Sent",
    mark_as_paid: "Mark as Paid",
    mark_as_awarded: "Mark as Awarded",
    mark_as_rejected: "Mark as Rejected",
    mark_as_void: "Mark as Void",
    mark_as_quoted: "Mark as Quoted",
    mark_as_invoiced: "Mark as Invoiced",
    mark_as_declined: "Mark as Declined",
    mark_as_quote_received: "Mark as Received",
    mark_as_write_off: "Mark as Write Off",
    mark_as_open: "Mark as Open",
    mark_as_partially_billed: "Mark as Partially Billed",
    mark_as_billed: "Mark as Billed",
    mark_as_closed: "Mark as Closed",
    mark_as_cancelled: "Mark as Cancelled",
    add_more: "Add More",
    delete_package: "Delete Package",
    create_bol: "Create Bill of Lading",
    unschedule: "Unschedule",
    rec_processed_qty: "Rec / Processed Qty",
    print_label: "Print Label",
    print_process_sheet: "Print Process Sheet",
    continuous: "Continuous",
    bill_of_ladings: "Bill Of Ladings",
    delete_bill_of_lading: "Delete Bill Of Lading",
    add_bill_of_lading: "Add Bill Of Lading",
    edit_bill_of_lading: "Edit Bill Of Lading",
    packing_list_id: "Packing List ID",
    vehicle_number: "Vehicle Number",
    total_ship_weight: "Total Ship Weight",
    cod_address: "REMIT COD TO ADDRESS",
    cod_amount: "COD Amount",
    cod_fee: "COD Fee",
    cod_fee_collect: "COD Fee Collect",
    declared_value: "Declared Value",
    total_charges: "Total Charges",
    freight_charges: "Freight Charges",
    freight_collect: "Freight Collect",
    shipper: "Shipper",
    shipper_number: "Shipper Number",
    signature: "Signature",
    signature_of_cosignor: "Signature of Cosignor",
    charge: "Charge",
    batch_price: "Batch Price",
    blanket_yes: "Blanket: Yes",
    blanket_no: "Blanket: No",
    has_nda: "Has NDA",
    has_contract: "Has Contract",
    control_id: "Control ID",
    part_code: "Part Code",
    charge_yes: "Charge: Yes",
    charge_no: "Charge: No",
    bol_number_short: "BOL #",
    no_shipments: "No Shipments",
    modify_shipping_carrier: "Modify Shipping Carrier",
    vendor: "Vendor",
    vendors: "Vendors",
    add_vendor: "Add Vendor",
    delete_vendor: "Delete Vendor",
    modify_vendor: "Modify Vendor",
    start: "Start",
    batch_count: "Batch Count",
    estimated_minutes_to_complete: "Estimated Minutes To Complete",
    click_enable_qc: "Click to enable Quality Control check",
    click_disable_qc: "Click to disable Qualtiy Control check",
    qc_enabled: "QC is Enabled",
    qc_disabled: "QC is Disabled",
    modify_batch: "Modify Batch",
    development_mode: "DEVELOPMENT MODE",
    final_check: "Final Check",
    microstructure: "Microstructure",
    error_saving: "Error Saving",
    minutes: "Minutes",
    destination: "Destination",
    reason_required: "Reason Required",
    single: "Single",
    multiple: "Multiple",
    confirm_delete_message_station: "Are you sure you want to delete this station?",
    confirm_delete_message_procedure: "Are you sure you want to delete this procedure?",
    confirm_delete_message_question: "Are you sure you want to delete this question?",
    location: "Location",
    error_jig_tag_number: "Jig tag number could not be located.",
    summary: "Summary",
    total_lots: "Total Lots",
    print_qr_codes: "Print QR Codes",
    add_note: "Add Note",
    note_details: "Note Details",
    delete_note: "Delete Note",
    updated_by: "Updated By",
    date_updated: "Date Updated",
    restrict_login_location: "Restrict Login Location",
    already_at_batch: "Already at batch",
    view_all: "View All",
    repack_shipping_unit_id: "Repack Shipping Unit",
    default_repack_shipping_unit: "Default Repack Shipping Unit",
    default_shipping_unit: "Default Shipping Unit",
    receiving_qty: "Receiving Qty",
    receiving_qty_pcs: "Receiving Qty (PCS)",
    show_less: "Show less",
    show_more: "Show more",
    are_you_sure: "Are you sure?",
    confirm_partial_batch: "Confirm Partial Batch",
    edit_widgets: "Edit Widgets",
    add_widgets: "Add Widgets",
    arrange_widgets: "Arrange Widgets",
    ship_label_type: "Ship Label Type",

    items: "Items",
    sales: "Sales",
    purchasing: "Purchasing",

    currency: "Currencies",
    manufacturers: "Manufacturers",
    select: "Select",
    unsigned: "This number can not be negative",
    warn_viewing_as_customer: "You are viewing this as a Customer. You will not be able to save any information.",
    warn_viewing_as_vendor: "You are viewing this as a Vendor. You will not be able to save any information.",
    calibrations: "Calibrations",
    astim_c138: "ASTM C138",
    type_b_concrete_air_meter: "Type B Concrete Air Meter",
    calibration_type_b_air_meter: "Type B Concrete Air Meters",
    volumetric_air_meter: "Volumetric Air Meter",
    procedures: "Procedures",
    aggregate_correction_factor: "Aggregate Correction Factor",
    c1542: "C1542",
    verifications: "Verifications",
    astim_c470_c31_cylinder_mold: "ASTM C470/C31 Cylinder Mold",
    c511_water_storage_temperature: "C511 (Water Storage/Temperature)",
    drilled_cores_42: "Drilled Cores (42)",
    mallet: "Mallet",
    measuring_device: "Measuring Device",
    sampling_freshly_mixed_concrete: "Sampling Freshly Mixed Concrete",
    scales_and_balances: "Scales & Balances",
    slump_cone: "Slump Cone",
    strike_off_bar: "Strike-Off Bar",
    strike_off_plate: "Strike-Off Plate",
    tamping_rod: "Tamping Rod",
    temperature_measuring_device: "Temperature Measuring Device",
    unbonded_cap: "Unbonded Cap",
    vibrator: "Vibrator",
    procedures: "Procedures",
    astm_c470_c31_cylinder_molds: "ASTM C470/C31 Cylinder Molds",
    astm_c31_beam_molds: "ASTM C31 Beam Molds",
    measuring_devices: "Measuring Devices",
    temperature_measuring_devices: "Temperature Measuring Devices",
    tamping_rods: "Tamping Rods",
    unbonded_caps: "Unbonded Caps",
    vibrators: "Vibrators",
    c1542s: "C1542s",
    RecentDataSessions: "Recent Data Sessions",
    RecentNotifications: "Recent Notifications",
    offline_devices: "Offline Devices",
    WeeklySales: "Weekly Sales",
    show_and_hide_widgets: "Show/Hide Widgets",
    widget_name: "Widget Name",
    configure_widgets: "Configure Widgets",
    fax: "Fax",
    licadas_youtube: "YouTube",
    pin_0: "Pin 0",
    pin_1: "Pin 1",
    pin_2: "Pin 2",
    pin_3: "Pin 3",
    pin_4: "Pin 4",
    pin_5: "Pin 5",
    pin_6: "Pin 6",
    pin_7: "Pin 7",
    pin_8: "Pin 8",
    pin_9: "Pin 9",
    pin_10: "Pin 10",
    pin_11: "Pin 11",
    pin_12: "Pin 12",
    pin_13: "Pin 13",
    pin_14: "Pin 14",
    pin_15: "Pin 15",
    pin_16: "Pin 16",
    cant_equal_zero: "Can't equal zero",
    cant_equal_zero: "Can't equal zero",
    icons: "Icons",
    confirm_logout: "Logout",
    remaining: "Remaining",
    full: "Full",
    confirm_location_label: "Confirm Location Label",
    administrator: "Administrator",
    dispatcher: "Dispatcher",
    technician: "Technician",
    driver: "Driver",
    "dispenser manager": "Dispenser Manager",
    dispenser_manager: "Dispenser Manager",
    developer: "Developer",
    csr: "CSR",
    "customer support": "Customer Support",
    customer_support: "Customer Support",
    "account manager": "Account Manager",
    account_manager: "Account Manager",
    producer: "Producer",
    customer_readonly: "Customer Read Only",
    "customer readonly": "Customer Read Only",
};
